__webpack_require__.p = "https://cdn.jsdelivr.net/npm/marketplacepos@2.2.5/Marketplace/";